module.exports = __webpack_public_path__ + "media/2.e1b21486.wav";